import * as React from 'react';
import { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from "react-redux";
import ListingComponent from '../ListingComponent';
import Icon from '../../icons';
import WorkkardCell from './workkardCell'
import { ATTACH_WORKKARD_FILES } from '../../containers/WorkkardDetail/constants'
import { getWorkkardActNoteFiles } from '@/containers/WorkkardDetail/actions/commonAction';
import Loader from "../../../app/components/Loader";

const AttachedWorkkardFiles = (props) => {
    const dispatch = useDispatch();
    const { hideDialogueBox, OnAttchFiles } = props;
    const { workkardDetail, createNote, activityListing } = useSelector(state => state.workkardDetail);
    const { isLoading, filesData } = createNote;
    const getActIds = activityListing?.activities?.map(_val => _val.activityId).join(',') ?? '';
    const [totalSelectedFiles, setTotalSelectedFiles] = useState([]);
    
    // Fetch workkard/Act note files
    useEffect(()=>{
        const payload = {
            cId: workkardDetail.Id,
            actId: getActIds,
        }
        dispatch(getWorkkardActNoteFiles(payload));
    }, [workkardDetail.Id, getActIds]);

    const normalizedFilesData = useMemo(() => {
        const seenGuids = new Set();
        return (filesData || []).reduce((normalized, item) => {
            if (seenGuids.has(item.FileGuid)) return normalized;
            seenGuids.add(item.FileGuid);
            normalized.push({
                id: item.FileGuid,
                file_name: item.FileName,
                guid: item.FileGuid,
                file_size: item.FileSize,
                caption: item.Caption,
                type: item.Ftype,
                file_type: item.FileType,
                file_preview_url: item.FilePreviewUrl
            });
            return normalized;
        }, []);
    }, [filesData]);
    
    //Select and deselect the File on Click
    const onItemClick = (item) => {
        setTotalSelectedFiles((prevSelected) => {
            const isAlreadySelected = prevSelected.some(({ guid }) => guid === item.guid);
            return isAlreadySelected
                ? prevSelected.filter((selected) => selected.guid !== item.guid)
                : [...prevSelected, { ...item }];
        });
    };

    const onAttachClick = () => {
        if (!totalSelectedFiles.length) return;
        OnAttchFiles(totalSelectedFiles);
    };
    
    const hasFiles = !!normalizedFilesData?.length;
    const showEmptyState = !hasFiles && !isLoading;
    
    return (
        <>
            <div className="modalHeader alignMiddle">
                <div className="flexGrow">
                    <h1>{ATTACH_WORKKARD_FILES} <span>({normalizedFilesData.length})</span></h1>
                    <strong>
                        {totalSelectedFiles.length} file(s) selected
                    </strong>
                </div>
                <button className="close btn link" onClick={() => hideDialogueBox()}>
                    <Icon name="close" className="icon ml" />
                </button>
            </div>
            <div className="modalBody">
                {
                    isLoading && <Loader />
                }
                {hasFiles &&
                    <div className={"attachWorkkardList fileAttachment largeView"}>
                        <ListingComponent
                            data={normalizedFilesData}
                            cellTemplate={WorkkardCell}
                            onItemClick={onItemClick}
                            type="ul"
                            selectedId=""
                            classname="poupScroll"
                        />
                    </div>
                }
                {showEmptyState &&
                    <div id="workkardListingError" className="error_m">
                        <span className="ex_ico" style={{ display: 'none' }}></span> No file present.
                    </div>
                }
            </div>

            <div className="modalFooter">
                <div className="rowFlex alignMiddle alignRight">
                    <button onClick={() => hideDialogueBox()} className="btn link">Cancel</button>
                    <button
                        onClick={onAttachClick}
                        className={!totalSelectedFiles.length ? "btn disabled" : 'btn default buttonGradient'}
                    >
                        Attach
                    </button>
                </div>
            </div>
        </>
    );
};

export default AttachedWorkkardFiles
